export const CONFIGURATION_STATUS = {
  NOT_STARTED: 'not_started',
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
} as const;

export type ConfigurationStatus =
  (typeof CONFIGURATION_STATUS)[keyof typeof CONFIGURATION_STATUS];
